import { useCallback, useMemo } from 'react';
import useSwr from 'swr';
import { useHistory } from 'react-router-dom';

import PollCardList from '@components/elements/PollCardList';

import { FormattedPoll, getPledgesFeed } from '@utils/Poll';

import { useAuth } from '@hooks/Auth';
import toast from 'react-hot-toast';
import { PollStatus } from '@sdk/models';

const UserPledgesPage: React.FC = () => {
  const history = useHistory<any>();
  const { dbUser } = useAuth();

  const { data } = useSwr(
    dbUser?.id ? ['/user/pledges', dbUser?.id] : null,
    getPledgesFeed,
    {
      revalidateOnFocus: false,
      onError: (err, key) => {
        console.log('Failed to fetch pledges', { key }, err);
        if(err?.message || err?.errors?.[0]?.message){
          toast.error(err?.message || err?.errors?.[0]?.message);
        }
    
      },
    }
  );

  const onPollSelect = useCallback(
    (poll: FormattedPoll) => {
      history.push(`/poll/${poll.id}`);
    },
    [history]
  );

  const [finishedPolls, recentPolls] = useMemo(() => {
    if (!data) return [undefined, undefined];
    console.log('data',data)
    const finished: FormattedPoll[] = [];
    const recent: FormattedPoll[] = [];

    data.forEach((poll) => {
      if (poll.status === PollStatus.END) finished.push(poll);
      else recent.push(poll);
    });

    return [finished, recent];
  }, [data]);

  return (
    <div>
      <h1 className="mt-8 mb-2 text-2xl font-bold text-white">Your Pledges</h1>

      {(finishedPolls?.length || 0) > 0 && (
        <>
          <h2 className="mt-8 mb-2 text-lg font-bold text-green">Completed</h2>
          <PollCardList
            data={finishedPolls}
            loading={!data}
            onSelect={onPollSelect}
            accessory="View Result"
          />
        </>
      )}

      {(recentPolls?.length || 0) > 0 && (
        <>
          <h2 className="mt-8 mb-2 text-lg font-bold text-cyan">
            On going pledges
          </h2>
          <PollCardList
            data={recentPolls}
            loading={!data}
            onSelect={onPollSelect}
            type="border"
            accessory="Manage"
          />
        </>
      )}
    </div>
  );
};

export default UserPledgesPage;
